/**
 * @file プルダウンリスト（Atom）。select要素のラッパー。OptionDefinition配列からoption要素を生成し、
 *        blank=trueで空選択肢を先頭に追加。react-hook-formのregisterに対応。
 */
import { CSSProperties, ChangeEventHandler, ReactElement } from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

/** 選択項目 */
export type OptionDefinition = {
  label: string;
  value: string;
  hidden?: boolean;
};

/** 属性定義 */
type Props = Partial<{
  options: OptionDefinition[];
  id: string;
  name: string;
  className: string;
  defaultValue: string | number | readonly string[];
  value: string | number | readonly string[];
  disabled: boolean;
  required: boolean;
  register: UseFormRegisterReturn;
  onChange: ChangeEventHandler<HTMLSelectElement>;
  error: FieldError;
  testid: string;
  blank: boolean;
  style: CSSProperties;
}>;

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtPulldownList = ({
  options,
  id,
  name,
  className,
  defaultValue,
  value,
  disabled,
  required,
  register,
  onChange,
  error,
  testid,
  blank,
  style,
}: Props) => {
  return (
    <select
      className={`m-form-select ${className || ''}`}
      id={id}
      name={name}
      defaultValue={defaultValue}
      value={value}
      disabled={disabled}
      required={required}
      {...register}
      onChange={onChange}
      aria-invalid={!!error}
      data-testid={testid}
      style={style}
    >
      {/* blank=trueの場合、未選択状態を表す空のoption要素を先頭に追加（disabled指定で選択不可にする） */}
      {blank && (
        <option aria-label='option' value='' disabled>
          &nbsp;
        </option>
      )}
      {options &&
        options.map((option: OptionDefinition): ReactElement => {
          return (
            <option hidden={option.hidden} value={option.value} key={option.value}>
              {option.label}
            </option>
          );
        })}
    </select>
  );
};
export default AtPulldownList;
